import { SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN, SET_ARTICLE_LABEL } from './actionTypes';
import { qiniuInfo } from '@/api/common'
import { getLabelList } from '@/api/label-manage';

export const getUrlAndTokenOfImageUpload = async ({ commit }) => {
  const response = await qiniuInfo()
  commit(SET_BUCKET_DOMAIN, response.data.BucketDomain)
  commit(SET_BUCKET_DOMAIN_TOKEN, response.data.token)
}

export const getAllArticlelabel = async ({ commit}) => {
  let postData = {
    page_index: '1',
    page_size: '99'
  }
  const response = await getLabelList(postData);
  commit(SET_ARTICLE_LABEL, response.data.data)
}
